import Listings from '../src/containers/Listings'

export default Listings
